// UI string translations + content helper. Base content language is Valencian ("va").

export const LANG_OPTIONS = [
  { code: "va", label: "Valencià" },
  { code: "es", label: "Castellà" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
];

export const UI = {
  va: {
    hero_kicker: "Bar · Tapes · Begudes",
    all: "Tot",
    no_items: "No hi ha plats disponibles.",
    cart_title: "La teva comanda",
    cart_empty: "El teu carret és buit",
    total: "Total",
    place_order: "Realitzar comanda",
    checkout_title: "Finalitzar comanda",
    name: "Nom",
    name_ph: "El teu nom",
    table: "Nº de Taula",
    table_ph: "Ex. 7",
    notes: "Notes",
    notes_ph: "Al·lèrgies, preferències…",
    confirm_order: "Confirmar comanda",
    sending: "Enviant…",
    order_success: "Comanda enviada! De seguida la preparem.",
    enter_name: "Introdueix el teu nom",
    consult: "Consultar",
    from: "des de",
    allergens: "Al·lèrgens",
    choose_size: "Tria la mida",
    add_to_order: "Afegir a la comanda",
    articles: "articles",
    admin: "Administració",
    allergen_notice: "IMPORTANT: Com que tots els nostres productes són elaborats de forma casolana i artesanal, poden contindre traces de qualsevol al·lergen.",
    photos_notice: "AVÍS: Les fotografies són merament orientatives i algunes han sigut generades mitjançant IA, per la qual cosa poden no coincidir exactament amb el producte final.",
  },
  es: {
    hero_kicker: "Bar · Tapas · Bebidas",
    all: "Todo",
    no_items: "No hay platos disponibles.",
    cart_title: "Tu pedido",
    cart_empty: "Tu carrito está vacío",
    total: "Total",
    place_order: "Realizar pedido",
    checkout_title: "Finalizar pedido",
    name: "Nombre",
    name_ph: "Tu nombre",
    table: "Nº de Mesa",
    table_ph: "Ej. 7",
    notes: "Notas",
    notes_ph: "Alergias, preferencias…",
    confirm_order: "Confirmar pedido",
    sending: "Enviando…",
    order_success: "¡Pedido enviado! Enseguida lo preparamos.",
    enter_name: "Introduce tu nombre",
    consult: "Consultar",
    from: "desde",
    allergens: "Alérgenos",
    choose_size: "Elige el tamaño",
    add_to_order: "Añadir al pedido",
    articles: "artículos",
    admin: "Administración",
    allergen_notice: "IMPORTANTE: Como todos nuestros productos son elaborados de forma casera y artesanal, pueden contener trazas de cualquier alérgeno.",
    photos_notice: "AVISO: Las fotografías son meramente orientativas y algunas han sido generadas mediante IA, por lo que pueden no coincidir exactamente con el producto final.",
  },
  en: {
    hero_kicker: "Bar · Tapas · Drinks",
    all: "All",
    no_items: "No dishes available.",
    cart_title: "Your order",
    cart_empty: "Your cart is empty",
    total: "Total",
    place_order: "Place order",
    checkout_title: "Complete order",
    name: "Name",
    name_ph: "Your name",
    table: "Table No.",
    table_ph: "e.g. 7",
    notes: "Notes",
    notes_ph: "Allergies, preferences…",
    confirm_order: "Confirm order",
    sending: "Sending…",
    order_success: "Order sent! We'll prepare it right away.",
    enter_name: "Enter your name",
    consult: "Ask us",
    from: "from",
    allergens: "Allergens",
    choose_size: "Choose size",
    add_to_order: "Add to order",
    articles: "items",
    admin: "Admin",
    allergen_notice: "IMPORTANT: All our products are homemade and artisanal, so they may contain traces of any allergen.",
    photos_notice: "NOTICE: Photographs are for illustrative purposes only and some have been generated using AI, so they may not exactly match the final product.",
  },
  fr: {
    hero_kicker: "Bar · Tapas · Boissons",
    all: "Tout",
    no_items: "Aucun plat disponible.",
    cart_title: "Votre commande",
    cart_empty: "Votre panier est vide",
    total: "Total",
    place_order: "Passer commande",
    checkout_title: "Finaliser la commande",
    name: "Nom",
    name_ph: "Votre nom",
    table: "Nº de Table",
    table_ph: "ex. 7",
    notes: "Notes",
    notes_ph: "Allergies, préférences…",
    confirm_order: "Confirmer la commande",
    sending: "Envoi…",
    order_success: "Commande envoyée ! Nous la préparons tout de suite.",
    enter_name: "Entrez votre nom",
    consult: "Consulter",
    from: "à partir de",
    allergens: "Allergènes",
    choose_size: "Choisissez la taille",
    add_to_order: "Ajouter à la commande",
    articles: "articles",
    admin: "Admin",
    allergen_notice: "IMPORTANT : Tous nos produits sont faits maison et artisanaux, ils peuvent donc contenir des traces de n'importe quel allergène.",
    photos_notice: "AVIS : Les photographies sont purement illustratives et certaines ont été générées par IA, elles peuvent donc ne pas correspondre exactement au produit final.",
  },
};

export function tContent(obj, lang) {
  if (!obj) return { name: "", description: "" };
  const tr = obj.translations && obj.translations[lang];
  if (lang === "va" || !tr) return { name: obj.name, description: obj.description || "" };
  return { name: tr.name || obj.name, description: tr.description || obj.description || "" };
}
